import { useCallback, useEffect, useState } from "react";

export function useLocalStorage<T>(key: string, initial: T) {
    const [value, setValue] = useState<T>(() => {
        try {
            const raw = localStorage.getItem(key);
            return raw !== null ? (JSON.parse(raw) as T) : initial;
        } catch {
            return initial;
        }
    });
    const set = useCallback(
        (v: T | ((p: T) => T)) =>
            setValue((prev) => {
                const next = typeof v === "function" ? (v as (p: T) => T)(prev) : v;
                try {
                    localStorage.setItem(key, JSON.stringify(next));
                } catch {
                    /* storage unavailable — run in-memory */
                }
                return next;
            }),
        [key],
    );
    return [value, set] as const;
}

export function useIsMobile(): boolean {
    const [mobile, setMobile] = useState(
        () => typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches,
    );
    useEffect(() => {
        const mq = window.matchMedia("(max-width: 767px)");
        const fn = () => setMobile(mq.matches);
        mq.addEventListener("change", fn);
        return () => mq.removeEventListener("change", fn);
    }, []);
    return mobile;
}
